<mat-dialog-content >
  <section class="w3l-form-25">
 <div class="form-inner-cont">
      <div class="w3l-form-25">
          <h1>{{documenttype}}</h1>
          <!-- <h1 style="color: rgb(79, 79, 161);font-weight: bolder;">{{ 'Edit Line' | translate }}</h1> -->
      </div>
    </div>

  <BR>


    <div id="w3l-appointment">
      <div class="wrapper">
      <div class="d-grid doctor-appointment">
        <form action="#" method="post" >

            <div class="appointment-form-field">
                <label style="width: 50px;font-weight: bold;">{{ 'Line' | translate }}</label>
                <label style="width: 20px;"></label>
                <label style="width: 250px;font-weight: bold;" [hidden]="true">{{ 'Document Name' | translate }}</label>
                <label style="width: 20px;"></label>
                <label style="width: 150px;font-weight: bold;">{{ 'Document Type' | translate }}</label>
                <label style="width: 20px;"></label>
                <label style="width: 150px;font-weight: bold;">{{ 'Date of Investigation' | translate }}</label>
                <label style="width: 20px;"></label>
                <label style="width: 100px;font-weight: bold;">{{ 'Discraption' | translate }}</label>

            </div>
            <div class="appointment-form-field">

              <input type="text" name="expcode"  required="" style="width: 50px;" disabled="true" [(ngModel)]="doccode" >
              <label style="width: 20px;"></label>
              <select id="trstore" name="trsstor" class="example-label" style="width: 250px;background-color:  rgb(187, 203, 238);" [(ngModel)]="docname"  [hidden]="true">
                <option *ngFor="let cur of imageList" value="{{cur.imagename}}" >{{cur.imagename}}</option>
              </select>
              <label style="width: 20px;"></label>
              <select id="kind" name="trkind" style="width: 150px;;background-color:  rgb(187, 203, 238);" [(ngModel)]= "doctype" [value]="doctype" (change)="Change_Image()" required>
                <option value="Image">Image</option>
                <option value="PDF">PDF</option>
                <option value="Excel">Excel</option>
                <option value="Word">Word</option>
            </select>
              <label style="width: 20px;"></label>
              <input type="date" name="textprice"  required="" style="width: 150px;" [(ngModel)]="docdate">
              <label style="width: 20px;"></label>

              <input type="text" name="textnots"  required="" style="width: 250px;" [(ngModel)]="docnotes">

          </div>
        </form>
      </div>
      </div>
    </div>
 <BR>
<div class="example-full-width" style="width: 100%;text-align: center;">
  <img src = "{{pathimage_1}}" alt="Item Image" width="20%" height="100px%" style="border: 1px;border-style: double;cursor: zoom-in;border-radius: 10%;" />
  <label style="width: 1%;" ></label>
  <input  type="file" id="photo"  (change)="picked($event)" name="photo" accept="all/*" style="width: 250px;">

</div>
  <BR>

    <mat-divider style="width: 100%;color:  #143d7b;"></mat-divider>
      <BR>
  <form style="text-align: center;">
      <button mat-raised-button style="width:15%;background-color:#067e06;color: #fffffe; height: 50px; font-size: 85%;font-weight: bolder;" (click)="Save_Date()">{{'Save' | translate}}</button>
      <label style="width: 1.5%;"></label>
      <button mat-raised-button style="width:15%;background-color:#c20508;color: #fffffe; height: 50px; font-size: 85%;font-weight: bolder;" (click)="MesgDelete()" >{{'Delete' | translate}}</button>
      <label style="width: 1.5%;"></label>
      <button mat-raised-button style="width:15%;background-color:#4abae7;color: #fffffe; height: 50px; font-size: 85%;font-weight: bolder;" (click)="CloseEdit()">{{'Close' | translate}}</button>

    </form>
  </section>
</mat-dialog-content>





